import { GVOpportunity } from 'models/GoldVision/GVOpportunities';
import { ActionType, getType } from 'typesafe-actions';

import * as gvOpportunitiesActions from './actions';
import { OpportunityKpi } from './actions';

export type GVOpportunitiesActionType = ActionType<
  typeof gvOpportunitiesActions
>;

export interface GVOpportunitiesState {
  gvOpportunities: GVOpportunity[];
  loading: boolean;
  totalRowCount: number;
  kpis: OpportunityKpi[];
  kpisAsOf: string | null;
  kpisLoading: boolean;
}

const initialState: GVOpportunitiesState = {
  gvOpportunities: [],
  loading: false,
  totalRowCount: 0,
  kpis: [],
  kpisAsOf: null,
  kpisLoading: false,
};

const gvOpportunitiesReducer = (
  state: GVOpportunitiesState = initialState,
  action: GVOpportunitiesActionType,
): GVOpportunitiesState => {
  switch (action.type) {
    case getType(gvOpportunitiesActions.getAllGVOpportunities.request):
      return {
        ...state,
        loading: true,
      };

    case getType(gvOpportunitiesActions.getAllGVOpportunities.success):
      return {
        ...state,
        gvOpportunities: action.payload.data.data,
        totalRowCount: action.payload.data.totalRowCount,
        loading: false,
      };

    case getType(gvOpportunitiesActions.getAllGVOpportunities.failure):
      return {
        ...state,
        loading: false,
      };

    case getType(gvOpportunitiesActions.getOpportunityKpis.request):
      return {
        ...state,
        kpisLoading: true,
      };

    case getType(gvOpportunitiesActions.getOpportunityKpis.success):
      return {
        ...state,
        kpis: action.payload.data.kpis,
        kpisAsOf: action.payload.data.as_of,
        kpisLoading: false,
      };

    case getType(gvOpportunitiesActions.getOpportunityKpis.failure):
      return {
        ...state,
        kpisLoading: false,
      };

    default:
      return state;
  }
};

export default gvOpportunitiesReducer;
